import { NavLink } from "react-router-dom";
import "../styles/NavBar.css";
import React from "react";

const NavBar = () => {
  return (
    <nav>
      <NavLink to="/">My W.I.C. Shopping Buddy</NavLink>
    </nav>
  );
};

export default NavBar;